import { batch } from "react-redux";
import types from "./actionTypes";
import { handleSnackBar, setSelectedEvent } from "../../global/actions";
import { deleteEventFromTransaction } from '../../constructs/transactions/actions'
import { getAllTransactions } from '../../constructs/transactions/selectors'
import { dealWithEvents } from '../../undoredo/actions'
import { getLuaEditorData } from '../../constructs/handlers/selectors'
import { getAllEvents } from './selectors'
import { onDeleteLuaFiles } from '../../constructs/handlers/actions'
import { getUserTriggers } from '../../constructs/user_triggers/selectors'
import { getRoutingRules } from '../../constructs/routing_rules/selectors';
import { deleteRrdef, editRrdef } from '../../constructs/routing_rules/actions';
import { deleteUserTrigger, editUserTrigger } from '../../constructs/user_triggers/actions';
import changeManager from '../../../services/eventSourceDestinationChangeManager';

export const addEvents = (payload, isWithEmbeddedTransactionId, noUndoRedo) => (dispatch, getState) => {

	dispatch({ type: types.ADD_EVENT, payload: payload });
	dispatch(handleSnackBar({ open: true, message: "Event has been created!", severity: "success" }));

}


export const addAnEvent = (payload) => ({
	type: types.ADD_EVENT,
	payload,
})

export const deleteEvent = (event, noUndoRedo) => (dispatch, getState) => {

	let associatedRRdef = [];
	let eventAssociatedData = {};
	let transactions = getAllTransactions(getState());
	let luaCodeData = getLuaEditorData(getState());
	let userTriggers = getUserTriggers(getState());
	let rrdefs = getRoutingRules(getState())

	const userTriggerforEvent = userTriggers.filter(ut => ut.attributes.op === event.id);
	if (userTriggerforEvent.length > 0) eventAssociatedData.associatedUTs = userTriggerforEvent;
	userTriggerforEvent.forEach(ut => dispatch(deleteUserTrigger(ut, true)));

	const luaForEvent = luaCodeData.filter(lua => lua.event == event.id);
	if (luaForEvent.length > 0) eventAssociatedData.associatedHandlers = luaForEvent;
	dispatch(onDeleteLuaFiles(luaForEvent));

	const rrdefforEvent = rrdefs.filter(rrdef => rrdef.attributes.tcmd === event.id);
	if (rrdefforEvent.length > 0) eventAssociatedData.associatedRRdef = rrdefforEvent;
	rrdefforEvent.forEach(rrdef => dispatch(deleteRrdef(rrdef, true)))


	transactions.forEach(transaction => {
		transaction.events.forEach(ev => {
			if (event.id == ev.id) {
				eventAssociatedData.order = ev.order;
				eventAssociatedData.parentTransactionId = transaction.id;
				dispatch(deleteEventFromTransaction(transaction.id, event))
			}
		})
	})

	if (noUndoRedo != true)
		dispatch(dealWithEvents(event, eventAssociatedData, 'delete'));

	/* delete from event list */
	dispatch({ type: types.DELETE_EVENT, event })

	/* delete event from transactions */


}

export const deleteEventOnly = (event) => (dispatch, getState) => {
	dispatch({ type: types.DELETE_EVENT, event })
}

/** Edit event */
export const editEvent = (event, noUndoRedo) => (dispatch, getState) => {

	let eventAssociatedData = {};
	if (event.handlers !== undefined) {
		eventAssociatedData.associatedHandlers = event.handlers;
		delete event.handlers;
	}

	if (noUndoRedo != true) dispatch(dealWithEvents(event, eventAssociatedData, 'edit'))

	dispatch({ type: types.EDIT_EVENT, event })
}

export const clusterletAssociatedEvents = (id) => (dispatch, getState) => {
	let events = getAllEvents(getState());
	const associatedEvents = events.filter(event => event.src === id || event.dst === id);
	return associatedEvents;
}

export const eventAssociatedtransactions = (id) => (dispatch, getState) => {
	let transactions = getAllTransactions(getState());
	const associatedTrans = transactions.map(transaction => {
		const eventIds = transaction.events.map(event => event.id);
		if (eventIds.includes(id)) return transaction.name
	}).filter(tr => tr)

	return associatedTrans;
}

export const updateFullEvents = (events) => ({
	type: types.UPDATE_FULL_EVENTS,
	payload: events
})

export const resetEvents = (events) => ({
	type: types.RESET_EVENTS,
	payload: events
})

export const deleteRrdefsAndUtsOfEvent =  (id, src, dst, eventData) => (dispatch, getState) => {
	
	let rrdefs = getRoutingRules(getState());
	let userTriggers = getUserTriggers(getState());
	let handlers = getLuaEditorData(getState());
	let associatedData = {};
	let selectedEvent = getAllEvents(getState()).find(event => event.id === id);
	const originalEvent = JSON.parse(JSON.stringify(selectedEvent));
	associatedData.original = originalEvent;

	const eventManager = new changeManager({orgEvent: originalEvent, sourceID: src, destinationID: dst});
	// console.log(eventManager)

	associatedData.associatedHandlers = eventManager.handlers;
	associatedData.rrdefs = eventManager.rrdefs;
	associatedData.userTriggers = eventManager.userTriggers;

	//undo-redo
	dispatch(dealWithEvents(eventManager.event, associatedData, 'edit'));

	
	//handlers
	dispatch(onDeleteLuaFiles(eventManager.handlers, true));

	//uts
	eventManager.userTriggers.deleteIds.forEach( ut => {
		const payload = { id: ut }
		dispatch(deleteUserTrigger(payload, true));
	})

	eventManager.userTriggers.editObjs.forEach( ut => {
		dispatch(editUserTrigger(ut, true));
	})

	//rrdefs
	eventManager.rrdefs.deleteIds.forEach(rrdef => {
		const payload = { id: rrdef }
		dispatch(deleteRrdef(payload, true));
	})

	eventManager.rrdefs.editObjs.forEach(rrdef => {
		dispatch(editRrdef(rrdef, true));
	})

	//event edit
	dispatch({type: types.EDIT_EVENT, event: eventManager.event });

}
